import UIModuleImportInconsistenciesModal from './UIModuleImportInconsistenciesModal';

export default UIModuleImportInconsistenciesModal;
